import { toast } from 'react-toastify';

const errorHandler = (error, position = "top-right") => {
    const options = {
        position: position,
        autoClose: 5000
    };

    if(error.response) {
        switch (error.response.status) {
            case 401:
                if ((error?.config?.url || '').includes('/admin/login/')) {
                    toast.error("Invalid username or password!", options);
                } else {
                    toast.error("Session expired or unauthorized. Please log in again.", options);
                }
                break;
            case 422:
                const error422 = error.response.data && error.response.data['error']
                    ? error.response.data['error']
                    : "Validation error occurred";
                toast.error(error422, options);
                break;
            case 400:
                const error400 = error.response.data && error.response.data.error && error.response.data.error[0]
                    ? error.response.data.error[0]
                    : "Bad request error occurred";
                toast.error(error400, options);
                break;
            default:
                toast.error("Error 446: Something went wrong!.", options);
        }
    } else {
        toast.error("Error 500: Server connection failed!.", options);
    }
};

export default errorHandler;
